import { render } from "./PaymentIndex.vue?vue&type=template&id=6cf3f99a&scoped=true"
import script from "./PaymentIndex.vue?vue&type=script&lang=js"
export * from "./PaymentIndex.vue?vue&type=script&lang=js"

import "./PaymentIndex.vue?vue&type=style&index=0&id=6cf3f99a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf3f99a"]])

export default __exports__